// extracted by mini-css-extract-plugin
module.exports = {"controls":"NameEdit_controls__3LRBc","field":"NameEdit_field__2VGn1","wrapper":"NameEdit_wrapper__JSbE4"};